import { Box, Divider, Text } from '@wix/design-system';
import React from 'react';
export const AltTextNoImagesGreenState = _ref => {
  let {
    description
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "SP2"
  }, /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(Text, {
    size: "tiny",
    weight: "thin",
    secondary: true
  }, description));
};
//# sourceMappingURL=alt-text-no-images-green-state.js.map